import { render, staticRenderFns } from "./TagesordnungLiveMeetingButton.vue?vue&type=template&id=0cb5ed6a"
import script from "./TagesordnungLiveMeetingButton.vue?vue&type=script&lang=js"
export * from "./TagesordnungLiveMeetingButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports